(function () {
  if (window.__productSliderExactSnapReady) return;
  window.__productSliderExactSnapReady = true;

  function getItems(slider) {
    return Array.from(slider.querySelectorAll('[id^="Slide-"]')).filter(function (item) {
      return item.clientWidth > 0;
    });
  }

  function getCurrentIndex(slider, items) {
    var firstOffset = items[0] ? items[0].offsetLeft : 0;
    var currentLeft = slider.scrollLeft + firstOffset;
    var closestIndex = 0;
    var closestDistance = Infinity;

    items.forEach(function (item, index) {
      var distance = Math.abs(item.offsetLeft - currentLeft);
      if (distance < closestDistance) {
        closestDistance = distance;
        closestIndex = index;
      }
    });

    return closestIndex;
  }

  function getSlidesPerPage(slider, items) {
    if (!items.length) return 1;

    var firstOffset = items[0].offsetLeft;
    var viewportWidth = slider.clientWidth;
    var count = items.filter(function (item) {
      return item.offsetLeft - firstOffset + item.clientWidth <= viewportWidth + 1;
    }).length;

    return Math.max(1, count);
  }

  function isVisible(slider, item) {
    var firstOffset = slider.querySelector('[id^="Slide-"]')?.offsetLeft || 0;
    var left = item.offsetLeft - firstOffset;
    var right = left + item.clientWidth;
    return left >= slider.scrollLeft - 1 && right <= slider.scrollLeft + slider.clientWidth + 1;
  }

  function update(root) {
    var slider = root.querySelector('[id^="Slider-"]');
    var prevButton = root.querySelector('button[name="previous"]');
    var nextButton = root.querySelector('button[name="next"]');
    var currentEl = root.querySelector('.slider-counter--current');
    var totalEl = root.querySelector('.slider-counter--total');
    if (!slider || !prevButton || !nextButton) return;

    var items = getItems(slider);
    if (items.length < 2) return;

    var index = getCurrentIndex(slider, items);
    var perPage = getSlidesPerPage(slider, items);
    var totalPages = Math.max(1, items.length - perPage + 1);
    var currentPage = Math.min(index + 1, totalPages);

    if (currentEl) currentEl.textContent = currentPage;
    if (totalEl) totalEl.textContent = totalPages;

    if (slider.scrollLeft <= 1 || isVisible(slider, items[0])) {
      prevButton.setAttribute('disabled', 'disabled');
    } else {
      prevButton.removeAttribute('disabled');
    }

    if (isVisible(slider, items[items.length - 1])) {
      nextButton.setAttribute('disabled', 'disabled');
    } else {
      nextButton.removeAttribute('disabled');
    }
  }

  // Vertically centre the overlay arrows on the product images (not on the whole card incl. text).
  function centerArrows(root) {
    var buttons = root.querySelectorAll('.slider-button--prev, .slider-button--next');
    if (!buttons.length) return;
    var slider = root.querySelector('[id^="Slider-"]');
    var item = slider && getItems(slider)[0];
    var media = item && (item.querySelector('.card__inner') || item.querySelector('.card__media'));

    buttons.forEach(function (button) {
      if (!media || getComputedStyle(button).position !== 'absolute' || !button.offsetParent) {
        button.style.top = '';
        return;
      }
      var mediaRect = media.getBoundingClientRect();
      var parentRect = button.offsetParent.getBoundingClientRect();
      if (!mediaRect.height) return;
      button.style.top = Math.round(mediaRect.top + mediaRect.height / 2 - parentRect.top) + 'px';
    });
  }

  function go(root, direction) {
    var slider = root.querySelector('[id^="Slider-"]');
    if (!slider) return;

    var items = getItems(slider);
    if (items.length < 2) return;

    var firstOffset = items[0].offsetLeft;
    var currentIndex = getCurrentIndex(slider, items);
    var perPage = getSlidesPerPage(slider, items);
    var maxStartIndex = Math.max(0, items.length - perPage);
    var targetIndex = Math.max(0, Math.min(maxStartIndex, currentIndex + direction * perPage));
    var targetLeft = items[targetIndex].offsetLeft - firstOffset;

    slider.scrollTo({ left: targetLeft, behavior: 'smooth' });
    window.setTimeout(function () {
      if (Math.abs(slider.scrollLeft - targetLeft) > 1) {
        slider.scrollTo({ left: targetLeft, behavior: 'auto' });
      }
      update(root);
    }, 350);
  }

  function init(root) {
    if (!root || root.dataset.exactSnapInitialized === 'true') return;

    var slider = root.querySelector('[id^="Slider-"]');
    var prevButton = root.querySelector('button[name="previous"]');
    var nextButton = root.querySelector('button[name="next"]');
    if (!slider || !prevButton || !nextButton) return;

    root.dataset.exactSnapInitialized = 'true';
    // Section CSS owns snapping: desktop arrows use exact offsets, while the
    // same cards form native snapping pages on mobile, including after resize.

    prevButton.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopImmediatePropagation();
      go(root, -1);
    }, true);

    nextButton.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopImmediatePropagation();
      go(root, 1);
    }, true);

    var ticking = false;
    slider.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        update(root);
        ticking = false;
      });
    }, { passive: true });

    window.addEventListener('resize', function () {
      update(root);
      centerArrows(root);
    });

    if ('ResizeObserver' in window) {
      new ResizeObserver(function () { centerArrows(root); }).observe(slider);
    }
    // Content above the images can still shift after init (web fonts, A/B-test scripts); re-measure once
    // things settle and whenever the slider scrolls into view.
    window.addEventListener('load', function () { centerArrows(root); });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { centerArrows(root); });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        if (entries.some(function (entry) { return entry.isIntersecting; })) centerArrows(root);
      }).observe(root);
    }

    update(root);
    centerArrows(root);
  }

  function initAll(scope) {
    (scope || document)
      .querySelectorAll('[data-exact-product-slider]')
      .forEach(init);
  }

  initAll();
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
